import * as bootstrap from 'bootstrap';

export default {
  mounted(el, binding) {
    const config = typeof binding.value === 'object'
      ? binding.value
      : { title: binding.value };

    // Set a default placement if none is provided
    if (!config.placement) {
      config.placement = binding.arg || 'top';
    }

    // Initialize Bootstrap tooltip and save instance on element for cleanup later
    el._tooltipInstance = new bootstrap.Tooltip(el, config);
  },
  updated(el, binding) {
    // Dispose of previous instance
    if (el._tooltipInstance) {
      el._tooltipInstance.dispose();
    }
    const config = typeof binding.value === 'object'
      ? binding.value
      : { title: binding.value };

    if (!config.placement) {
      config.placement = binding.arg || 'top';
    }
    // Reinitialize tooltip with updated config
    el._tooltipInstance = new bootstrap.Tooltip(el, config);
  },
  unmounted(el) {
    // Clean up tooltip instance when element is removed
    if (el._tooltipInstance) {
      el._tooltipInstance.dispose();
    }
  }
};
